'use client';

import { useCategoryStore } from '@eliadmin/core/src/stores/category-store';
import { useCallback } from 'react';
import { resetCategoryFilterPage } from '@/utils/category-filter-actions';

/** Compose user controls only; the core parser and history restoration stay untouched. */
export function useCategoryFilterActions() {
  const setFilter = useCategoryStore(state => state.setFilter);
  const clearFilters = useCategoryStore(state => state.clearFilters);
  return {
    setFilter: useCallback(
      (filter: Parameters<typeof setFilter>[0]) => {
        resetCategoryFilterPage();
        setFilter(filter);
      },
      [setFilter],
    ),
    clearFilters: useCallback(() => {
      resetCategoryFilterPage();
      clearFilters();
      // The core reset restores slider bounds; zero means no price constraint in the URL.
      setFilter({ price_min: 0, price_max: 0 });
    }, [clearFilters, setFilter]),
  };
}
